export default __webpack_public_path__ + "static/media/light_learning_catalog.84b9f240.png";